import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'
import { OpenInquiryOverlay } from '@tv3/store/overlay/overlay.actions'
@Component({
  selector: 'app-booking-results-table',
  templateUrl: './booking-results-table.component.html',
  styles: [
    `
      table {
        width: 100%;
      }
    `,
  ],
})
export class BookingResultsTableComponent implements OnInit {
  @Input() results: any[] = []

  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['title', 'rental', 'guestArrive', 'guestDepart', 'personCount']

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.dataSource.data = this.results || []
  }

  onEdit(booking: any) {
    this.store.dispatch(OpenInquiryOverlay({ inquiryId: booking.pkey }))
  }
}
